import React, { Fragment } from "react";
import { Box, Button, Card, Grid2 as Grid, Stack, Typography } from "@mui/material";
import { ArrowCircleLeft, ArrowCircleRight } from "@phosphor-icons/react";
import { GenericIconButton } from "../../../components/generic/GenericIconButton";
import useStore from "../../../states/store";

export const CreatorEvents = ({ handleOpenRequestCollabDialog, canCollab, hasLoggedUser, currentUser }) => {
  const [, { setSignUpDialogState }] = useStore();
  return (
    <Card sx={{ mt: 3, mb: 3 }}>
      <Grid container justifyContent={'space-between'}>
        <Grid item>
          <Typography variant="h2" mb={2} fontSize={'1.25rem'} fontWeight={800} color="primary">Upcoming Events</Typography>
        </Grid>
        <Grid item>
          <Stack direction={'row'} color={'primary.main'}>
            <GenericIconButton
              disabled={true}
              color={'primary.main'}
              icon={<ArrowCircleLeft size={24} />}
            />
            <GenericIconButton
              disabled={true}
              color={'primary.main'}
              icon={<ArrowCircleRight size={24} />}
            />
          </Stack>
        </Grid>
      </Grid>
      <Box sx={{ display: 'flex', alignItems: 'center', justifyContent: 'center', backgroundColor: 'background.lightBlue', height: '200px', borderRadius: '8px' }}>
        <Stack gap={1.5}>
          {
            currentUser ? <Fragment>
              <Typography variant="subtitle1" color="text.light" textAlign={'center'}>
                You currently have no upcoming events scheduled at this time.
              </Typography>
            </Fragment> : <Fragment>
              <Typography variant="subtitle1" color="text.light" textAlign={'center'}>
                No upcoming events.
              </Typography>
              {
                canCollab && <Button
                  variant="contained"
                  size="large"
                  onClick={() => hasLoggedUser ? handleOpenRequestCollabDialog() : setSignUpDialogState(true)}
                >
                  Wanna Collab?
                </Button>
              }
            </Fragment>
          }
        </Stack>
      </Box>
      {/* <Grid container spacing={2}>
        <Grid item size={{ xs: 12, md: 4 }}>
          <Box sx={{ padding: '10px', borderRadius: '10px', backgroundColor: 'background.lightBlue' }}>
            <Grid container spacing={1.5} alignItems={'center'}>
              <Grid item>
                <Box
                  sx={{
                    height: '66px',
                    backgroundColor: 'primary.main',
                    borderRadius: '10px',
                    padding: '5px 16px',
                    color: '#FFF'
                  }}>
                  <Stack alignItems={'center'}>
                    <Typography fontSize={'10px'}>SEP</Typography>
                    <Typography variant="h4" fontWeight={700}>24</Typography>
                  </Stack>
                </Box>
              </Grid>
              <Grid item>
                <Typography fontWeight={500}>Brand Promotion Photoshoot</Typography>
                <Stack direction={'row'} alignItems={'center'} mt={0.5} gap={0.5} color={'text.light'}>
                  <MapPinLine size={16} />
                  <Typography fontSize={'10px'} color="text.semiLight" fontWeight={500}>Philippines</Typography>
                </Stack>
              </Grid>
            </Grid>
          </Box>
        </Grid>
      </Grid> */}
    </Card>
  );
};